import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Location } from '../../models';
import { SafePipe } from '@teamfoster/sdk/text-utility';
import { ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { MatAccordion, MatExpansionModule, MatExpansionPanel, MatExpansionPanelHeader } from '@angular/material/expansion';
import { DatePipe, JsonPipe, NgClass } from '@angular/common';
import { IconComponent } from '@teamfoster/sdk/icon';

@Component({
  selector: 'app-location-card',
  standalone: true,
  imports: [StripEmbedPipe, ResizeHtmlImagesPipe, SafePipe, MatAccordion, MatExpansionModule, JsonPipe, DatePipe, NgClass, IconComponent],
  templateUrl: './location-card.component.html',
  styleUrl: './location-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationCardComponent {
  location = input.required<Location>();
  isBig = input<boolean>();

  openPanel: number | null = null;

  dayOfWeekToDate(dayOfWeek: number) {
    // return new Date()
    return new Date().setDate(new Date().getDate() + ((dayOfWeek - 1 - new Date().getDay() + 7) % 7) + 1);
  }
}
